import styled from "styled-components"
import { AlignBox, XBtn } from '../atom';
import { trackEvent } from "../apis/amplitude";

export const PopUp = (
    { BtnHandler, xBtnHandler }: 
    { BtnHandler: () => void , xBtnHandler: () => void}
    ) => {

    return (
        <PopUpBox>
            <PopUpConatiner>
                <XBtn onClick={xBtnHandler} />
                <p style={{fontSize: "40px"}}>😭</p>
                <div style={{height: '21px'}}/>
                <b style={{color: "white", fontSize: "24px"}}>지금은 사람이 없어요..</b>
                <div style={{height: '55px'}}/>
                <Btn onClick={BtnHandler}>텀블벅 이벤트로 친구 만날 수 있어요!</Btn>
            </PopUpConatiner>
        </PopUpBox>
    )
}

export const TimeoutPopUp = ({xHandler}:any) => {

    return (
        <PopUpBox>
            <PopUpConatiner style={{height: '330px'}}>
                <XBtn onClick={xHandler} />
                <div style={{height: '21px'}}/>
                <p style={{fontSize: "40px"}}>🤫</p>
                <div style={{height: '21px'}}/>
                <b style={{color: "white", fontSize: "24px"}}>
                    지금! 텀블벅에서 더 보기
                </b>
                <TumblbugBox />
                {/* <ProfileBox /> */}
            </PopUpConatiner>
        </PopUpBox>
    )
}


export const SharePopUp= (
    { xBtnHandler }: 
    { xBtnHandler: () => void}
    ) => {
    return (
        <PopUpBox>
            <PopUpConatiner style={{height: '330px'}}>
                <XBtn onClick={xBtnHandler} />
                <div style={{height: '21px'}}/>
                <p style={{fontSize: "40px"}}>💬</p>
                <div style={{height: '21px'}}/>
                <b style={{color: "white", fontSize: "24px"}}>
                    익명으로 링크를 공유하고 <br/>
                    사람을 더 모아봐요
                </b>
                <ShareBox />
            </PopUpConatiner>
        </PopUpBox>
    )
}

const ShareBox = () => {
    
    const twitterUrl = process.env.PUBLIC_URL + `/twitter.png`
    const kakaoUrl = process.env.PUBLIC_URL + `/kakao.png`
    const ctrlcUrl = process.env.PUBLIC_URL + `/ctrlc.png`

    return(
        <AlignBox align="center" direction="row" style={{height:'10px'}}>
            <AlignBox align="center" direction="column">
                <img onClick={
                    ()=>
                    navigator.clipboard.writeText("soul-demo-client.vercel.app")
                    .then(() => {
                      trackEvent('커뮤 링크 복사')
                      alert('링크가 복사되었습니다 ☺️');
                    })
                } src={ctrlcUrl} />
                <div style={{height: '10px'}}/>
                <p style={{color: 'white', fontSize: '15px', fontWeight: '700'}}>
                    커뮤니티 등 <br/>
                    원하는 곳
                </p>
            </AlignBox>
            <AlignBox align="center" direction="column">
                <img src={kakaoUrl} onClick={()=>
                    navigator.clipboard.writeText(
                        "https://soul-demo-client.vercel.app"
                    )
                    .then(() => {
                      trackEvent('카톡 링크 복사')
                      alert('링크가 복사되었습니다 ☺️');
                    })
                }/>
                <div style={{height: '10px'}}/>
                <p style={{color: 'white', fontSize: '15px', fontWeight: '700'}}>
                    단톡 or 오픈채팅 <br/>ㅤ
                </p>
            </AlignBox>
            <AlignBox align="center" direction="column">
                <img src={twitterUrl} onClick={()=>{
                        window.open("https://twitter.com/intent/tweet?text="
                        + "%0A----------------------%0A"
                        + "나랑 실시간으로 대화해요. 취향이 맞다면요.%0A"
                        + "취향이 맞는 소울메이트 찾기, 지금 소울에서%0A%0A"
                        + "&url=https://soul-demo-client.vercel.app");
                        trackEvent('트위터 리트윗')
                }}/>
                <div style={{height: '10px'}}/>
                <p style={{color: 'white', fontSize: '15px', fontWeight: '700'}}>
                    트위터 <br/>ㅤ
                </p>
            </AlignBox>
        </AlignBox>
    )
}

const ProfileBox = () => {
    
    const twitterUrl = process.env.PUBLIC_URL + `/twitter.png`
    const instaUrl = process.env.PUBLIC_URL + `/insta.png`

    return(
        <AlignBox align="center" direction="row" style={{height:'10px'}}>
            <AlignBox align="center" direction="column">
                <img src={twitterUrl} onClick={()=>{
                        window.open("https://twitter.com/soulappteam");
                        trackEvent('트위터 프로필 이동')
                }}/>
                <div style={{height: '10px'}}/>
                <p style={{color: 'white', fontSize: '15px', fontWeight: '700'}}>
                    트위터로 볼래 <br/>
                </p>
            </AlignBox>
            <AlignBox align="center" direction="column">
                <img src={instaUrl} onClick={()=>{
                        window.open("https://www.instagram.com/soulappteam");
                        trackEvent('인스타 프로필 이동')
                }}/>
                <div style={{height: '10px'}}/>
                <p style={{color: 'white', fontSize: '15px', fontWeight: '700'}}>
                    인스타로 볼래 <br/>
                </p>
            </AlignBox>
        </AlignBox>
    )
}

const TumblbugBox = () => {
    
    const tumblbugUrl = process.env.PUBLIC_URL + `/tumblbug.png`

    return(
        <AlignBox align="center" direction="row" style={{height:'10px'}}>
            <AlignBox align="center" direction="column">
                <img src={tumblbugUrl} onClick={()=>{
                        window.open("https://tum.bg/E86JBR");
                        trackEvent('텀블벅 프로필 이동')
                }}/>
                <div style={{height: '10px'}}/>
                <p style={{color: 'white', fontSize: '15px', fontWeight: '700'}}>
                    텀블벅에선 더 엄청나! <br/>
                </p>
            </AlignBox>
        </AlignBox>
    )
}


const Btn = styled.div`
    bottom: 40px;

    font-weight: 700;
    
    display: flex;
    justify-content: center;
    align-items: center;
    width: 268px;
    height: 55px;
    background-color: #fff;
    border-radius: 32px;
    color: #000;
`


const PopUpConatiner = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    position: fixed;
    bottom: 2px;
    left: 50%;

    transform: translate(-50%, 0);

    width: calc(100vw - 5px);
    height: 300px;

    background-color: black;
    border-radius: 40px;
    z-index: 2;
`

const PopUpBox = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    width: 100vw;
    height: 100vh;

    background-color: #00000080;
    z-index: 1;
`